import React from "react";
import Layout from "../../components/user/Layout";
import Notification from "../../components/Notification";

const NotificationPage = () => {
  return (
    <>
      <Layout>
        <Notification />
      </Layout>
    </>
  );
};

export default NotificationPage;
